export const INVESTOR_NOTICE = [
  '투자자는 본 서비스에 대하여 당사로부터 충분한 설명을 받을 권리가 있으며, 당사와 투자일임계약을 체결하기 전에 투자일임계약 권유문서 및 투자일임계약서를 반드시 읽어 보시기 바랍니다.',
  '공모주 및 투자일임계약은 예금자보호법에 따라 보호되지 않습니다.',
  '공모주는 가격 변동에 따라 투자 원금의 일부 또는 전부 손실이 발생할 수 있으며, 투자 손익은 전부 투자자 본인에게 귀속됩니다.',
  '투자일임 수수료는 투자일임계약서 상 고객과의 합의에 의하며, 이외에도 거래 수수료 및 청약수수료가 발생합니다.',
  '공모주에 대한 청약의 권유는 주관 증권회사에서 제공하는 투자설명서에 따릅니다.',
  '공모주 일반투자자에게는 균등 배정 방식과 비례 배정 방식이 적용되어 각 배정 방식에 따라 공모주 배정 결과가 다를 수 있습니다.',
  '공모주는 통상 상장 초기 가격 변동성이 크며, 상장 후 시가가 공모가를 하회할 경우 투자 손실이 크게 발생할 수도 있습니다.',
]

export const SAMSUNG_NOTICE = [
  '해당 이벤트는 일육공에서 삼성증권 계좌를 처음 개설하신 고객을 대상으로 합니다.',
  '이자 수령을 위해서는 일육공을 통해 삼성증권 계좌를 개설하시고 온라인타인 등록을 마치셔야 합니다.',
  '이자가 지급되는 예수금은 최소 50만원 ~ 최대 100만원 입니다.(예수금 100만원 초과 금액은 이자가 계산되지 않습니다.)',
  '계좌개설 익일부터 일별로 이자가 계산되어 6개월간 지급됩니다.',
  '이자는 삼성증권 계좌개설 후, 매 4주차 금요일마다 지급합니다.',
  '예수금 이자는 삼성증권 계좌로 엠엘투자자문에서 지급합니다.',
  '예수금 잔고가 50만원 미만으로 떨어질 경우, 이자가 지급되지 않으며, 이벤트 대상에서 제외되어 다시 참가하실 수 없습니다.',
  '혜택 기간(6개월) 중, 일육공에서 삼성증권 공모주 청약이 있을 경우 자동으로 청약될 수 있습니다.',
  '공모주 청약 중에는 예수금 잔고 + 청약증거금을 기준으로 이자를 계산합니다.',
  '일육공은 자체 알고리즘을 통해, 공모주별 매력지수를 산정, 50점 미만이 나올 경우, 고객의 리스크 관리를 위해 청약을 진행하지 않습니다.',
  '중도해지 시, 혜택 지급이 중단됩니다.',
  '탈퇴 후 재가입 이력이 있는 경우, 이벤트 대상에서 제외됩니다.',
  '혜택 지급일 기준, 고객정보 오류(계좌주 오류, 연락처 결번, 착신 정지, 수신 정지 등)일 경우, 혜택 지급이 불가할 수 있습니다.',
  '다른 이름과 연락처, 계좌로 혜택 지급을 요구하는 경우, 지급이 취소될 수 있습니다.',
  '이벤트 내용과 기간은 엠엘투자자문 및 삼성증권 사정에 의해 변동될 수 있습니다.',
  '혜택 수령 후, 사후 처리의 책임은 고객 본인에게 있습니다.',
]
